
const refs ={
    closeModal: document.querySelector("[data-modal-close]"),
    modal: document.querySelector("[data-modal]")
}


const closeModal = (e)=>{

    if(e.target !== refs.modal && e.target !==refs.closeModal){

        return
    }
    refs.modal.style.display = "none";
}
refs.modal.addEventListener("click", closeModal);
refs.closeModal.addEventListener("click", closeModal)